import { QuestionType } from './enums';

const listAttributes = [
  'questionId',
  'label',
  'maxMark',
  'type',
  'answer',
  'optionsCount',
  'mcqOpts',
  'analytics',
  'criteria',
  'guides',
] as const;

const getAttributes = [
  ...listAttributes,
  'examSubject',
  'examId',
  'creationDatetime',
  'editDatetime',
  'topics',
  'active',
] as const;

const updateAttributes = ['label', 'criteria', 'guides', 'editDatetime'] as const;

export const LegacyExamQuestionAttributes = {
  List: listAttributes,
  Get: getAttributes,
  Update: updateAttributes,
};

export const QUESTION_TYPES: {
  key: QuestionType;
  value: QuestionType;
  label: string;
  analyticsKey:
    | 'calculationAnalytics'
    | 'proofAnalytics'
    | 'shortAnswerAnalytics'
    | 'extendedResponseAnalytics'
    | 'multipleChoiceAnalytics'
    | 'graphingAnalytics';
}[] = [
  {
    key: QuestionType.Calculation,
    value: QuestionType.Calculation,
    label: 'Calculation',
    analyticsKey: 'calculationAnalytics',
  },
  {
    key: QuestionType.Proof,
    value: QuestionType.Proof,
    label: 'Proof',
    analyticsKey: 'proofAnalytics',
  },
  {
    key: QuestionType.ShortAnswer,
    value: QuestionType.ShortAnswer,
    label: 'Short answer',
    analyticsKey: 'shortAnswerAnalytics',
  },
  {
    key: QuestionType.ExtendedResponse,
    value: QuestionType.ExtendedResponse,
    label: 'Extended response',
    analyticsKey: 'extendedResponseAnalytics',
  },
  {
    key: QuestionType.MultipleChoice,
    value: QuestionType.MultipleChoice,
    label: 'Multiple choice',
    analyticsKey: 'multipleChoiceAnalytics',
  },
  {
    key: QuestionType.Graphing,
    value: QuestionType.Graphing,
    label: 'Graphing / diagrams',
    analyticsKey: 'graphingAnalytics',
  },
];
